// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "environment/v1/environment.proto" (package "environment.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private environment RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message environment.v1.AuthConfig
 */
export interface AuthConfig {
    /**
     * @generated from protobuf field: string client_id = 1;
     */
    clientId: string;
    /**
     * @generated from protobuf field: string audience = 2;
     */
    audience: string;
}
/**
 * BuildInfo carries the raw VCS/build components of the running server binary,
 * derived from Go's -buildvcs stamping and the go.viam.com/api dependency. The
 * frontend composes these into a human-readable build identifier. All fields are
 * empty for binaries built without VCS stamping (e.g. -buildvcs=false).
 *
 * @generated from protobuf message environment.v1.BuildInfo
 */
export interface BuildInfo {
    /**
     * Resolved version of the go.viam.com/api dependency, e.g. "v0.1.569".
     *
     * @generated from protobuf field: string api_version = 1;
     */
    apiVersion: string;
    /**
     * Full git commit SHA the binary was built from.
     *
     * @generated from protobuf field: string git_commit = 2;
     */
    gitCommit: string;
    /**
     * Commit timestamp of git_commit, RFC3339 (e.g. "2026-07-18T19:30:00Z").
     *
     * @generated from protobuf field: string commit_time = 3;
     */
    commitTime: string;
    /**
     * Go toolchain version the binary was built with, e.g. "go1.25.12".
     *
     * @generated from protobuf field: string go_version = 4;
     */
    goVersion: string;
}
/**
 * @generated from protobuf message environment.v1.Environment
 */
export interface Environment {
    /**
     * The address used for WebRTC signaling. This is different in production, staging, and when running locally.
     *
     * @generated from protobuf field: string signaling_address = 1;
     */
    signalingAddress: string;
    /**
     * @generated from protobuf field: string app_base_url = 2;
     */
    appBaseUrl: string;
    /**
     * @generated from protobuf field: environment.v1.AuthConfig auth_config = 3;
     */
    authConfig?: AuthConfig;
    /**
     * @generated from protobuf field: environment.v1.EnvironmentType environment_type = 5;
     */
    environmentType: EnvironmentType;
    /**
     * The org ID of the viam support org
     *
     * @generated from protobuf field: string support_org_id = 6;
     */
    supportOrgId: string;
    /**
     * Whether or not to disable inkeep for the given environment
     *
     * @generated from protobuf field: bool enable_inkeep = 7;
     */
    enableInkeep: boolean;
    /**
     * The URL of the LSP service for code editor syntax checking
     *
     * @generated from protobuf field: string lsp_service_url = 8;
     */
    lspServiceUrl: string;
    /**
     * Build metadata for the running server binary. Absent for unstamped builds.
     *
     * @generated from protobuf field: environment.v1.BuildInfo build_info = 9;
     */
    buildInfo?: BuildInfo;
    /**
     * Fragment id of the public ViamShellDanger fragment (builtin shell with root).
     * Staging and production use different fragments.
     *
     * @generated from protobuf field: string viam_shell_danger_fragment_id = 10;
     */
    viamShellDangerFragmentId: string;
}
/**
 * @generated from protobuf message environment.v1.GetEnvironmentRequest
 */
export interface GetEnvironmentRequest {
}
/**
 * GetEnvironment is an unauthenticated route. Do not return sensitive data.
 *
 * @generated from protobuf message environment.v1.GetEnvironmentResponse
 */
export interface GetEnvironmentResponse {
    /**
     * @generated from protobuf field: environment.v1.Environment environment = 1;
     */
    environment?: Environment;
}
/**
 * Matches env.go
 *
 * @generated from protobuf enum environment.v1.EnvironmentType
 */
export enum EnvironmentType {
    /**
     * @generated from protobuf enum value: ENVIRONMENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ENVIRONMENT_TYPE_DEVELOPMENT = 1;
     */
    DEVELOPMENT = 1,
    /**
     * @generated from protobuf enum value: ENVIRONMENT_TYPE_TEST = 2;
     */
    TEST = 2,
    /**
     * @generated from protobuf enum value: ENVIRONMENT_TYPE_STAGING = 3;
     */
    STAGING = 3,
    /**
     * @generated from protobuf enum value: ENVIRONMENT_TYPE_STAGING_TEMP = 4;
     */
    STAGING_TEMP = 4,
    /**
     * @generated from protobuf enum value: ENVIRONMENT_TYPE_PRODUCTION = 5;
     */
    PRODUCTION = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class AuthConfig$Type extends MessageType<AuthConfig> {
    constructor() {
        super("environment.v1.AuthConfig", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "audience", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message environment.v1.AuthConfig
 */
export const AuthConfig = new AuthConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BuildInfo$Type extends MessageType<BuildInfo> {
    constructor() {
        super("environment.v1.BuildInfo", [
            { no: 1, name: "api_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "git_commit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "commit_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "go_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message environment.v1.BuildInfo
 */
export const BuildInfo = new BuildInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Environment$Type extends MessageType<Environment> {
    constructor() {
        super("environment.v1.Environment", [
            { no: 1, name: "signaling_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_base_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "auth_config", kind: "message", T: () => AuthConfig },
            { no: 5, name: "environment_type", kind: "enum", T: () => ["environment.v1.EnvironmentType", EnvironmentType, "ENVIRONMENT_TYPE_"] },
            { no: 6, name: "support_org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "enable_inkeep", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "lsp_service_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "build_info", kind: "message", T: () => BuildInfo },
            { no: 10, name: "viam_shell_danger_fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message environment.v1.Environment
 */
export const Environment = new Environment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEnvironmentRequest$Type extends MessageType<GetEnvironmentRequest> {
    constructor() {
        super("environment.v1.GetEnvironmentRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message environment.v1.GetEnvironmentRequest
 */
export const GetEnvironmentRequest = new GetEnvironmentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEnvironmentResponse$Type extends MessageType<GetEnvironmentResponse> {
    constructor() {
        super("environment.v1.GetEnvironmentResponse", [
            { no: 1, name: "environment", kind: "message", T: () => Environment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message environment.v1.GetEnvironmentResponse
 */
export const GetEnvironmentResponse = new GetEnvironmentResponse$Type();
/**
 * @generated ServiceType for protobuf service environment.v1.InternalEnvironmentService
 */
export const InternalEnvironmentService = new ServiceType("environment.v1.InternalEnvironmentService", [
    { name: "GetEnvironment", options: {}, I: GetEnvironmentRequest, O: GetEnvironmentResponse }
]);
